import FormatGeoJSON from '../node_modules/ol/format/GeoJSON.js';

import bboxClip from '../node_modules/@turf/bbox-clip';

/**
 * Uses TurfJs. Returns a new feature that is clipped to
 * the extent of the current view. Useful for labeling, especially lines.
 * @param {Feature} feature
 */

export default function(feature) {
  const formatGeoJSON = new FormatGeoJSON()
  let geom = formatGeoJSON.writeGeometryObject(feature.getGeometry()) // convert feature from OL to geoJSON format
  let extent = this.map.getView().calculateExtent()
  let clipped = bboxClip(geom, extent)
  let oLgeom
  try {
    oLgeom = formatGeoJSON.readGeometry(clipped.geometry) // convert geoJSON to OpenLayers format
  } catch (error) {
    console.warn ('Caught clipToExtent', error)
  }
  return oLgeom
}
